import React from 'react';
import Image from "../../assets/hero-img-slider-1.jpg"
import AboutImage1 from "../../assets/About-img-1.jpg"
import AboutImage2 from "../../assets/About-Image-2.jpg"

const OurStory: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-12 md:mb-0">
            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                {/* <img
                  src={Image}
                  alt="Our early days"
                  className="rounded-lg shadow-lg transform translate-y-6"
                /> */}
                <img
                  src={AboutImage1}
                  alt="Company growth"
                  className="rounded-lg shadow-lg"
                />
                <img
                  src={AboutImage2}
                  alt="Office culture"
                  className="rounded-lg shadow-lg"
                />
                <img
                  src={Image}
                  alt="Modern workplace"
                  className="rounded-lg shadow-lg transform translate-y-6"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-blue-100 rounded-full blur-3xl opacity-70"></div>
              <div className="absolute -z-10 -top-10 -right-10 w-64 h-64 bg-indigo-100 rounded-full blur-3xl opacity-70"></div>
            </div>
          </div>

          <div className="md:w-1/2 md:pl-16">
            <div className="inline-flex items-center space-x-2 mb-4">
              <div className="h-px w-8 bg-blue-600"></div>
              <span className="text-sm font-semibold text-blue-600 uppercase tracking-wider">Our Journey</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              From Startup to Industry Leader
            </h2>

            <p className="text-gray-600 mb-6">
              Founded in 2018 by a team of passionate technologists, our journey began in a small garage with a big vision.
              What started as a three-person team working on custom software solutions has evolved into a global
              technology company with offices in 1 country.
            </p>

            <p className="text-gray-600 mb-8">
              Throughout our growth, we've remained true to our founding principles: putting clients first,
              embracing innovation, and creating technology that makes a difference. Our team has grown to over
              10+ experts, but we maintain the agility and creativity of our startup roots.
            </p>

            <div className="grid grid-cols-2 gap-8">
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">12+</div>
                <div className="text-gray-700">Years of Excellence</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">10+</div>
                <div className="text-gray-700">Team Members</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">1</div>
                <div className="text-gray-700">Global Offices</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">100+</div>
                <div className="text-gray-700">Projects Delivered</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;